import {publishAddCopilotChatReference, publishOpenCopilotChat} from '@github-ui/copilot-chat/utils/copilot-chat-events'
import {CopilotChatIntents, type FileDiffReference} from '@github-ui/copilot-chat/utils/copilot-chat-types'
import {sendEvent} from '@github-ui/hydro-analytics'
import {useToastContext} from '@github-ui/toast/ToastContext'
import {ActionList} from '@primer/react'
import {populateSnippetRanges} from './populate-snippet-ranges'

const itemSx = {px: 5, borderRadius: 0, whiteSpace: 'nowrap'} as const

export interface CopilotChatDiffMenuItem {
  fileDiffReference: FileDiffReference
}

export const CopilotChatDiffMenuItem = ({fileDiffReference}: CopilotChatDiffMenuItem) => {
  const {addToast} = useToastContext()

  const discuss = () => {
    publishOpenCopilotChat({
      intent: CopilotChatIntents.discussFileDiff,
      references: [populateSnippetRanges(fileDiffReference)],
    })
    sendEvent('copilot.file-diff.menu.discuss')
  }

  const addReference = () => {
    publishAddCopilotChatReference(populateSnippetRanges(fileDiffReference))
    addToast({message: 'Reference added to thread', type: 'success'})
    sendEvent('copilot.file-diff.menu.add')
  }

  return (
    <>
      <ActionList.Item onSelect={discuss} sx={itemSx} role="menuitem">
        Ask Copilot about this diff
      </ActionList.Item>
      <ActionList.Item onSelect={addReference} sx={itemSx} role="menuitem">
        Attach to current thread
      </ActionList.Item>
    </>
  )
}

try{ CopilotChatDiffMenuItem.displayName ||= 'CopilotChatDiffMenuItem' } catch {}